import { useEffect, useState } from "react";
import { getAllTransactions, deleteTransaction } from "./TransactionService";
import { getAllAccounts } from "../accounts/AccountService";
import { getAllCategories } from "../categories/CategoryService";
import { getAllMerchants } from "../merchants/MerchantService";
import "./TransactionList.css";

export default function TransactionList(){

  const [txns,setTxns] = useState([]);
  const [accounts,setAccounts] = useState([]);
  const [categories,setCategories] = useState([]);
  const [merchants,setMerchants] = useState([]);

  useEffect(()=>{
    load();
  },[]);

  const load = async ()=>{
    const data = await getAllTransactions();
    setTxns(Array.isArray(data) ? data : []);
    setAccounts(await getAllAccounts());
    setCategories(await getAllCategories());
    setMerchants(await getAllMerchants());
  };

  const nameById = (arr,id,key)=>{
    return arr.find(x=>x.id===id)?.[key] || "-";
  };

  const handleDelete = async (id)=>{
    if(!window.confirm("Delete transaction?")) return;
    await deleteTransaction(id);
    load();
  };

  return (
    <div className="transaction-list-wrap">
      <h2 className="transaction-list-title">Transactions</h2>

      <div className="transaction-list-list">
        {txns.map(t=>(
          <div key={t.id} className="transaction-list-card">

            <div className="transaction-list-left">
              <div className={`transaction-list-badge transaction-list-badge-${(t.transactionType || "").toLowerCase()}`}>
                {t.transactionType}
              </div>

              <div className="transaction-list-main-info">
                <div className={`transaction-list-amount transaction-list-amount-${(t.transactionType || "").toLowerCase()}`}>
                  ₹ {t.transactionAmount}
                </div>

                <div className="transaction-list-meta">
                  {t.merchantId 
                    ? nameById(merchants,t.merchantId,"merchantName")
                    : "Transfer"
                  } • {t.transactionDate}
                </div>

                <div className="transaction-list-sub">
                  {t.categoryId 
                    ? nameById(categories,t.categoryId,"categoryName")
                    : "—"
                  } • {
                    t.accountId 
                      ? nameById(accounts,t.accountId,"accountName")
                      : `${nameById(accounts,t.fromAccountId,"accountName")} → ${nameById(accounts,t.toAccountId,"accountName")}`
                  }
                </div>

                {t.description && (
                  <div className="transaction-list-desc">{t.description}</div>
                )}
              </div>
            </div>

            <div>
              <button onClick={()=>handleDelete(t.id)} className="transaction-list-del-btn">🗑️</button>
            </div>

          </div>
        ))}
      </div>
    </div>
  );
}
